/* MrRizz — „Číst více“ u karty značky.
   Tlačítko se ukáže jen když je text opravdu delší než ořez, jinak zůstane skryté. */
(() => {
  const SELECTOR = '[data-brand-toggle]';

  const body = (btn) => document.getElementById(btn.getAttribute('aria-controls'));

  const setLabel = (btn, expanded) => {
    const label = btn.querySelector('[data-brand-toggle-label]');
    if (!label) return;
    label.textContent = expanded
      ? btn.dataset.labelLess || label.textContent
      : btn.dataset.labelMore || label.textContent;
  };

  /* Změřit se dá jen ve sbaleném stavu – rozbalený element přeteče vždy. */
  const refresh = (btn) => {
    const el = body(btn);
    if (!el) return;
    if (btn.getAttribute('aria-expanded') === 'true') return;

    const text = el.querySelector('.brand-card__text');
    if (!text) return;

    const overflows = text.scrollHeight - text.clientHeight > 4;
    btn.hidden = !overflows;
    if (!overflows) el.dataset.brandClamp = 'false';
    else el.dataset.brandClamp = 'true';
  };

  const toggle = (btn) => {
    const el = body(btn);
    if (!el) return;
    const expanded = btn.getAttribute('aria-expanded') === 'true';
    btn.setAttribute('aria-expanded', expanded ? 'false' : 'true');
    el.dataset.brandClamp = expanded ? 'true' : 'false';
    setLabel(btn, !expanded);
  };

  const init = (root = document) => {
    root.querySelectorAll(SELECTOR).forEach((btn) => {
      if (btn.dataset.brandReady === '1') return;
      btn.dataset.brandReady = '1';
      btn.addEventListener('click', () => toggle(btn));
      refresh(btn);
      /* Fonty dojedou později a přepočítají výšku řádků. */
      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(() => refresh(btn)).catch(() => {});
      }
    });
  };

  const refreshAll = () => document.querySelectorAll(SELECTOR).forEach(refresh);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  let resizeTimer = null;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(refreshAll, 150);
  });

  /* Editor motivu překresluje sekce za běhu. */
  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('shopify:block:select', (event) => init(event.target));
})();
